import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actionCreators } from "../redux/averageNumberOfVisitsPerClientSagas";

export const UpdateButtons = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.averageNumberOfVisitsPerClient.filtersDirty);

  const {
    isFiltersLoading,
    primaryCategoriesLoading,
    secondaryCategoriesLoading,
    pricingOptionsLoading
  } = useSelector((state) => state.averageNumberOfVisitsPerClient);

  return filtersDirty ? (
    <>
      <button
        className="submit"
        disabled={
          isFiltersLoading ||
          primaryCategoriesLoading ||
          secondaryCategoriesLoading ||
          pricingOptionsLoading
        }
        onClick={() => dispatch(actionCreators.updateData())}
      >
        Update
      </button>

      <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
        Reset
      </button>
    </>
  ) : (
    ""
  );
};
